import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { HeadphonesIcon } from 'lucide-react';

const SupportTickets = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Support Tickets</h1>
        <p className="text-gray-600 mt-1">Manage customer support requests</p>
      </div>

      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <HeadphonesIcon className="w-5 h-5 text-blue-600" />
            <CardTitle>Customer Support</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12 text-gray-500">
            <HeadphonesIcon className="w-12 h-12 mx-auto mb-4 text-blue-400" />
            <p>View and respond to support tickets</p>
            <p className="text-sm mt-2">Backend integration pending</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SupportTickets;